import Swal from "sweetalert2";
import 'sweetalert2/src/sweetalert2.scss';
export const Showalert = async ({
  title,
  text,
  icon = "warning", 
  confirmButtonText = "Yes", 
  cancelButtonText = "Cancel", 
  confirmButtonColor = "#3085d6",
  cancelButtonColor = "#d33",
  callback,
  setLoading = () => {},
}) => {
  Swal.fire({
    title: title || "Alert",
    text: text || "This is a custom alert.",
    icon: icon,
    showCancelButton: true,
    confirmButtonColor: confirmButtonColor,
    cancelButtonColor: cancelButtonColor,
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    showClass: {
      popup: "animate__animated animate__fadeInUp animate__faster",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutDown animate__faster",
    },
  }).then(async (result) => {
    if (result.isConfirmed && callback) {
      setLoading(true); // Set loading state
      try {
        await callback(); // Call the passed callback
      } catch (error) {
        console.error("Error in custom alert callback:", error);
      } finally {
        setLoading(false); // Reset loading state
      }
    }
  });
};
